<template>
    <div class="d-flex flex-column h-100 position-relative">
        <div class="navigator" style="height: 65px;">
            <h2 class="mr-auto">Reports</h2>

            <div class="col-md-2 ml-auto">
                <v-select :options="timeOptions" v-model="selectedTimeOption" @input="rangeDropdownChanged"></v-select>
            </div>

            <div class="d-flex flex-row align-items-center" v-if="selectedTimeOption.value == 'custom'">
                <i class="ico ico-calendar fs-large dark mr-3"></i>

                <date-picker-new
                    class="dateRangePicker"
                    :key="pickerKey"
                    v-model="customDate"
                    :range="true"
                    :clearOutside="true"
                    :showFromTo="false"
                    @input="dateRangeChanged">
                </date-picker-new>
            </div>
        </div>

        <div v-if="dashboardData == null" class="dark fs-larger font-weight-600 text-center mt-4">
            <loader></loader>
        </div>

        <div v-else class="d-flex mt-1 px-5 mb-2 flexGrow1 overflow-auto align-items-start">
            <div class="row w-100">
                <div class="col-md-6 col-lg-3">
                    <cardGraphOccupancy 
                        class="mt-3" 
                        title="Occupancy" 
                        :subTitle="cardLabel" 
                        :loading="!dashboardData" 
                        :percent="dashboardData.occupancy.totalOccupancyPercentage" 
                        :label="dashboardData.occupancy.totalOccupancy + ' of ' +dashboardData.occupancy.total" 
                        :labelColor="'#FF00FF'">
                    </cardGraphOccupancy>
                </div>

                <div class="col-md-6 col-lg-3" v-if="showTotalSales">
                    <cardSimple 
                        class="mt-3" 
                        title="Total Sales" 
                        :subTitle="cardLabel" 
                        :value1="dashboardData.sales.totalSales+'€'" 
                        :value2="dashboardData.sales.totalTickets + ' Bookings'" 
                        :value2Class="'color-3'">
                    </cardSimple>
                </div>

                <div class="col-md-6 col-lg-3">
                    <cardSimple 
                        class="mt-3" 
                        title="Avg. Sale / Person" 
                        :subTitle="cardLabel" 
                        :value1="dashboardData.sales.averageSalePerPersonExtended">
                    </cardSimple>
                </div>

                <div class="col-md-6 col-lg-3">
                    <cardSimple 
                        class="mt-3" 
                        title="Canceled" 
                        :subTitle="cardLabel" 
                        :value1="dashboardData.sales.totalCancellations">
                    </cardSimple>
                </div>

                <div class="col-md-12 col-lg-6">
                    <cardGraphSummary 
                        class="mt-3" 
                        :title="'Ticket Sales'" 
                        :graphLabels="dashboardData.chart.labels" 
                        :graphValues="dashboardData.chart.data">
                    </cardGraphSummary>
                </div>

                <div class="col-md-12 col-lg-6">
                    <card-download class="mt-3" :subTitle="cardLabel" :dateFrom="pickerDateFrom" :dateTo="pickerDateTo"></card-download>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import cardSimple from './cardSimple'
import cardGraphOccupancy from './cardGraphOccupancy'
import cardGraphSummary from './cardGraphSummary'
import cardReportList from './cardReportList'
import cardDownload from './cardDownload'
import extendedVSelect from '@/extends/vue-select'
import VueDatepicker from 'vuejs-datepicker'
import Loader from '@/tools/loaders/loader1'
import DatePickerNew from '@/tools/DatePicker'

export default {
    data() {
        return {
            timeOptions: [
                { label:'Today', value:'today' },
                { label:'This Week', value:'week' },
                { label:'This Month', value:'month' },
                { label:'Custom', value:'custom' }
            ],
            selectedTimeOption: {
                label:'This Month',
                value:'month'
            },
            customDate: [],
            thisMonth: '',
            dateFrom: null,
            dateTo: null,
            dashboardData: null,
            pickerKey: 0
        }
    },
    created() {
        // Gets the current month
        var todayDate = new Date();
        var thisMonthIndex = todayDate.getMonth();

        var monthsArr = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]

        this.thisMonth = monthsArr[thisMonthIndex];
        this.dateFrom = moment().startOf('month');
        this.dateTo = moment().endOf('month');

        this.getDashboardData();
    },
    computed: {
        ...mapGetters([
            'account',
        ]),
        showTotalSales() {
            return this.accessPermissionFilter([
                'admin',
                'mainSupervisor'
            ]);
        },
        pickerDateFrom: {
            get() {
                return moment(this.dateFrom).format('YYYY-MM-DD');
            },
            set(value) {
                this.dateFrom = moment(value);
            }
        },
        pickerDateTo: {
            get() {
                return moment(this.dateTo).format('YYYY-MM-DD');
            },
            set(value) {
                this.dateTo = moment(value);
            }
        },
        cardLabel() {
            var selectedTimeOption = this.selectedTimeOption;
            var outputLabel = '';

            switch (selectedTimeOption.value) {
            case 'month':
                outputLabel = this.thisMonth;
                break;

            case 'custom':
                outputLabel = moment(this.dateFrom).format('YYYY-MM-DD') +' to '+  moment(this.dateTo).format('YYYY-MM-DD');
                break;

            default:
                outputLabel = selectedTimeOption.label;
            }

            return outputLabel;
        }
    },
    methods:{
        ...mapActions([
            'refreshAccountData'
        ]),
        dateRangeChanged() {           
            this.pickerDateFrom = this.customDate[0];
            this.pickerDateTo = this.customDate[1];
            
            this.getDashboardData();
        },
        getDashboardData() {
            this.dashboardData = null;

            axios.get('/api/Supplier/GetPerformanceResume',{
                params: {
                    's.supplierId': this.account.supplierId,
                    's.dateStart': moment(this.dateFrom).format("YYYY-MM-DD"),
                    's.dateEnd': moment(this.dateTo).format("YYYY-MM-DD"),
                }
            }).then(response => {
                if(response.status == 200){
                    this.dashboardData = response.data;
                }
            })
        },
        rangeDropdownChanged(e) {
            if (e == null) {
                this.selectedTimeOption = {
                    label:'Today',
                    value:'today'
                }
            }

            let newDateFrom = null;
            let newDateTo = null;
            let currentDateFromMoment = moment(this.dateFrom);
            let currentDateToMoment = moment(this.dateTo);

            switch (e.value) {
                case 'custom':
                    newDateFrom = moment().startOf('month');
                    newDateTo = moment().endOf('month');
                    
                    // Updates the date-picker array to reflect these dates
                    this.customDate = [newDateFrom.format('YYYY-MM-DD'), newDateTo.format('YYYY-MM-DD')];
                    break;
                case 'today':
                    newDateFrom = moment().startOf('day');
                    newDateTo = moment().endOf('day');
                    break;

                case 'week':
                    newDateFrom = moment().startOf('week');
                    newDateTo = moment().endOf('week');
                    break;

                case 'month':
                    newDateFrom = moment().startOf('month');
                    newDateTo = moment().endOf('month');
                    break;

                default:
                    newDateFrom = moment().startOf('day').format('YYYY-MM-DD');
                    newDateTo = moment().endOf('day').format('YYYY-MM-DD');
            }

            const DATE_FORMAT = 'YYYY-MM-DD';
            const newDateFromFormatted = newDateFrom.format(DATE_FORMAT);
            const newDateToFormatted = newDateTo.format(DATE_FORMAT);
            const currentDateFromFormatted = currentDateFromMoment.format(DATE_FORMAT);
            const currentDateToFormatted = currentDateToMoment.format(DATE_FORMAT);

            // This validation prevents pulling the same range twice
            if (newDateFromFormatted === currentDateFromFormatted && newDateToFormatted === currentDateToFormatted) {
                return;
            }

            this.dateFrom = newDateFrom;
            this.dateTo = newDateTo;
            this.getDashboardData();
        }
    },
    components:{
        cardSimple,
        cardGraphOccupancy,
        cardGraphSummary,
        cardReportList,
        cardDownload,
        vSelect: extendedVSelect,
        VueDatepicker,
        Loader,
        DatePickerNew
    }
}
</script>

<style lang="scss" scoped>
    .card-height-2 {
        height: 350px;
    }

    .fs-super-big {
        font-size: 3rem;
    }

    .dateRangePicker {
        min-width: 250px;
    }
</style>



// WEBPACK FOOTER //
// Reports.vue?159c455d